import ImageWithPlaceholderColor from './image-with-placeholder-color'

export default ImageWithPlaceholderColor
